import type {
  AppContentCurrentEntity,
  AppContentVersionEntity,
} from '../entities/app-content.entity';
import type { AppContentKey } from '../entities/app-content.entity';
import type { AppContentRepository } from '../repositories/app-content-repository.interface';

export class GetAppContentUseCase {
  private readonly repository: AppContentRepository;

  constructor(repository: AppContentRepository) {
    this.repository = repository;
  }

  async executeCurrent(key: AppContentKey): Promise<AppContentCurrentEntity | null> {
    return this.repository.getCurrentContent(key);
  }

  async executeVersions(key: AppContentKey): Promise<AppContentVersionEntity[]> {
    return this.repository.getVersions(key);
  }
}
